<script setup>
import { ref,watch, computed } from "vue";
import { useI18n } from "vue-i18n";
import LocalStorage from '@/controller/LocalStorage.js';
import defaultImage from '../../../../public/assets/default-car.jpg';
import flechaStart from '../../../../public/assets/svg/flecha_start.svg';
import { getStatusText, matchStatusToSvg } from "@/services/api/Mappings.js";
import { useCommunicatorStore } from '@/stores/communicator.js';
import { useRouter } from 'vue-router';
import YBtn from "../form/YBtn/YBtn.vue";
import MazSwitch from 'maz-ui/components/MazSwitch';
import { isAuthorized } from "@/utils/Authorization.js";
import Oks from "@/components/common/Oks/Ok.vue";
import { useToast } from 'maz-ui'

const router = useRouter();
const toast = useToast()
const isNotifications = computed(() => router.currentRoute.value.path === '/notifications');
const communicatorStore = useCommunicatorStore();
const props = defineProps({
  item: Object,
  field: String,
  type: String,
  src: String,
  styles: Object,
  expandable: Boolean,
  isExpanded: Boolean,
  tableStates: Object,
  path: String,
  navigation: String,
  table: String,
  title: String
});

const emit = defineEmits(["updateVehicleList","toggleExpand","updateLinkedClient","syncVehicle"]);

const userColor = ref(LocalStorage.getColor());
const userSecondaryColor = ref(LocalStorage.getColorSecondary());
const userTertiaryColor = ref(LocalStorage.getColorTertiary());
const selectedColor = ref(LocalStorage.getColorSelected());
const hoverSelectedColor = ref(LocalStorage.getColorSelectedHover());

const resyncVehicleMessageAct = ref(false);
const resyncVehicleMessageDeact = ref(false);

//Iniciamos reparationDate con el valor de props.item.reparationDate convertido a fecha DD/MM/YYYY HH:MM
const reparationDate = ref('');


const { t } = useI18n();
const isLoadedImg = ref(false);
const ull = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 41.349 30.89">
  <g id="Grupo_2278" data-name="Grupo 2278" transform="translate(1.5 1.5)">
    <g id="Grupo_591" data-name="Grupo 591" transform="translate(0 0)">
      <path id="Trazado_376" data-name="Trazado 376" d="M367.944,381.889c0,3.351,6.3,13.945,19.175,13.945s19.174-10.594,19.174-13.945S400,367.944,387.119,367.944s-19.175,10.593-19.175,13.945" transform="translate(-367.944 -367.944)" fill="none" stroke="#B2BDCE" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
    </g>
    <circle id="Elipse_546" data-name="Elipse 546" cx="6.973" cy="6.973" r="6.973" transform="translate(12.202 6.973)" fill="none" stroke="#B2BDCE" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
  </g>
</svg>
`;

//Flags workfiles list
const outOfStockFilterIsPresent = ref(document.querySelector('label[data-filter="missing_parts"]') !== null );
const over24hFilterIsPresent = ref(document.querySelector('label[data-filter="over24h"]') !== null );
//Flags workfiles list

let date = "";
let startDate = "";
let deliveryDate = "";
let endDate = "";
let carImage = null;
let link = null;
let doubleLink = null;
let btnState = ref({});
let buttons = [];
if (['nextVisitDate','tachographDate','itvDate'].includes(props.field)) { 
  date = '';
  if(props.item[props.src] !== null && props.item[props.src] !== '' && parseInt(props.item[props.src]) > 0) {
    date = new Date(parseInt(props.item[props.src]) * 1000).toLocaleString([], {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    }).replace(',', '');
  }
}
else if (props.field == 'date' || props.field == 'created') {
  date = new Date(props.item[props.src] * 1000).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' });
}
else if (props.field == 'daterange') {
  startDate = new Date(props.item.date * 1000).toLocaleString([], {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
}).replace(',', '');
}
else if (props.field == 'reparationDate') {
  if (props.item.reparationDate) {
  const dateObj = new Date(props.item.reparationDate * 1000);
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  reparationDate.value = `${day}/${month}/${year} ${hours}:${minutes}`;
}
}

else if (props.field == 'deliveryDate') {
  if(props.item.deliveryDate){
    deliveryDate = new Date(props.item.deliveryDate * 1000).toLocaleString([], {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).replace(',', '');
  }
}
else if (props.field == 'image') {
  if (props.item && props.item['svgImage'] != 'null' && props.item['svgImage'] != '') {
    let propImage = props.item['svgImage']
    watch(() => propImage,
    (image) => {
      const img = new Image();
      img.onload = () => (isLoadedImg.value = true);
      img.src = image;
    },
    { immediate: true })
  } 
  else if (props.item && props.item['image'] != 'null' && props.item['image'] != '') {
    let propImage = props.item['image']
    watch(() => propImage,
    (image) => {
      const img = new Image();
      img.onload = () => (isLoadedImg.value = true);
      img.src = image;
    },
    { immediate: true })
  } else {
    carImage = defaultImage;
    isLoadedImg.value = true;
  }
} 
else if (props.field == 'linkId' && props.type != 'doubleLink') {
  link = '/' + props.item['linkId']
}
else if(props.field == 'linkId' && props.type == 'doubleLink') {
  doubleLink = props.item['linkId'];
}
else if (props.field == 'link' && props.type == 'file') {
  link = props.item['link'];
}
else if (props.field == 'link' && props.type == 'notificationLink') {
  if(props.item.type == 3 ){
    link = '/invitation/' + props.item.data.invitationId;
  }else{
    link = '/workfile/' + props.item.data.workfileId;
  }
}
else if(props.field == 'buttons') {
  let types = JSON.parse(props.type);
  types.forEach(element => {
    switch (element) {
      case 'detail':
        buttons.push({
          type: 'detail',
          link:'/'+props.path+'/'+props.item.id,
          icon:'assets/svg/ull_obert.svg',
          svg:`<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 41.349 30.89">
                  <g id="Grupo_2278" data-name="Grupo 2278" transform="translate(1.5 1.5)">
                    <g id="Grupo_591" data-name="Grupo 591" transform="translate(0 0)">
                      <path id="Trazado_376" data-name="Trazado 376" d="M367.944,381.889c0,3.351,6.3,13.945,19.175,13.945s19.174-10.594,19.174-13.945S400,367.944,387.119,367.944s-19.175,10.593-19.175,13.945" transform="translate(-367.944 -367.944)" fill="none" stroke="#B2BDCE" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                    </g>
                    <circle id="Elipse_546" data-name="Elipse 546" cx="6.973" cy="6.973" r="6.973" transform="translate(12.202 6.973)" fill="none" stroke="#B2BDCE" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                  </g>
                </svg>` 
        });
        break;

      case 'negotiate':
        if(isAuthorized('validateWorkfile')){
          buttons.push({
            type: 'negotiate',
            link:props.item.data.negotiation_url, 
            icon:'assets/svg/pendent.svg',
            svg:`<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 41.197 28.647">
                    <g id="flecha" transform="translate(31.891 30.961) rotate(180)">
                      <path id="Trazado_1216" data-name="Trazado 1216" d="M.057,4.13A12.409,12.409,0,0,1,9.289,0a12.694,12.694,0,0,1,12.56,12.824A12.694,12.694,0,0,1,9.289,25.647,12.407,12.407,0,0,1,0,21.454" transform="translate(8.542 3.814)" fill="none" stroke="#B2BDCE" stroke-linecap="round" stroke-miterlimit="10" stroke-width="3"/>
                      <line id="Línea_753" data-name="Línea 753" x2="21.663" transform="translate(14.28 16.476) rotate(180)" fill="none" stroke="#B2BDCE" stroke-linecap="round" stroke-miterlimit="10" stroke-width="3"/>
                      <path id="Trazado_1217" data-name="Trazado 1217" d="M0,12.156,6.829,6.082,0,0" transform="translate(-0.977 22.558) rotate(180)" fill="none" stroke="#B2BDCE" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                    </g>
                  </svg>`
          });
        }
        break;
      default:
        break;
    }
  });
}


function updateTableVehicle() {
  emit('updateVehicleList', props.item.id);
}

function showToast (msg,options) {
    const toastMessage = toast.success(msg, options);
}


function syncVehicles(action){
  if (action == 'activate') {
        resyncVehicleMessageAct.value = true;
        resyncVehicleMessageDeact.value = false;
        showToast(t('client.sync_vehicle_activation'), {
            position: 'bottom-right',
            timeout: 3000,
            class: 'toast-sync'
        });
        setTimeout(()=> {
            resyncVehicleMessageAct.value = false;
        }, 3000);
    } else if (action == 'deactivate') {
        resyncVehicleMessageDeact.value = true;
        resyncVehicleMessageAct.value = false;
        showToast(t('client.sync_vehicle_deactivation'), {
            position: 'bottom-right',
            timeout: 3000,
            class: 'toast-sync'
        });
        setTimeout(()=> {
            resyncVehicleMessageDeact.value = false;
        }, 3000);
  }

  emit('syncVehicle', props.item.id, action);
}
function getValueByPath(obj, path) {
  let keys = path.split('.');
  let current = obj;
  for (let i = 0; i < keys.length; i++) {
    if(current == null) return null;
    current = current[keys[i]];
  }
  if(path == 'image' && obj.svgImage && obj.svgImage.length) return obj.svgImage;
  if(path == 'data.branch.name') return current.charAt(0).toUpperCase() + current.slice(1).toLowerCase();

  return current;
}
function toggleExpand(event) {
  if(props.expandable) {
    emit('toggleExpand');
  }
}
function updateLinkedClient() {
  emit('updateLinkedClient');
}
function setUserToEdit() {
  communicatorStore.setSelectedUser(props.item);
}
function convertMinutesToHoursAndMinutes(minutes) {
  let decimal = Math.ceil(minutes - Math.floor(minutes));
  let hours = Math.floor(minutes / 60);
  let remainingMinutes = (Math.floor(minutes) % 60);
  remainingMinutes += decimal;
  return `${hours}h ${remainingMinutes}m`;
}

function formatDate(timestamp) {
  let date = new Date(timestamp);
  let year = date.getUTCFullYear();
  let month = String(date.getUTCMonth() + 1).padStart(2, '0');
  let day = String(date.getUTCDate()).padStart(2, '0');
  let hours = String(date.getUTCHours()).padStart(2, '0');
  let minutes = String(date.getUTCMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}
function goToDetail() {
  if(props.navigation && props.navigation !== '') {
    router.push(props.navigation + props.item.id);
  }
}
const isMobileScreen = () => {
      return window.innerWidth <= 1024;   
};

const isMobileView = () => {
  return window.innerWidth <= 500;
};

const handleClick = (event) => {
      if (isMobileScreen()) {
        goToDetail();
      }
      else{
        toggleExpand(event)
      }
};



</script>

<template>
  <div :class="{'custom-table-cell-home': props.table === 'homePendingWorkfiles', 'custom-table-cell' : props.table !== 'homePendingWorkfiles'}" @dblclick="goToDetail" @click="handleClick" >
    <div class="cell-img" v-if="field == 'image'">
      <img :src="carImage" v-if="carImage" />
      <img :src="getValueByPath(item, src)" v-else />
    </div> 
    <div class="cell cell-date-range" :class="{'cell-date-range-workfile' : props.table === 'vehicleWorkfilesList'}" v-else-if="field == 'daterange'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <div class="startDate">
        <div class="dateIcon">
          <img :src="flechaStart" style="width:0.8dvw;"/>
        </div>
        <div class="dateText">{{ startDate }}</div>
      </div>
    </div>
    <div class="cell cell-date-range" :class="{'cell-date-range-workfile' : props.table === 'vehicleWorkfilesList'}" v-else-if="field == 'reparationDate'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <div class="startDate">
        <div class="dateText">{{ reparationDate }}</div>
      </div>
    </div>
    <div class="cell cell-date-range" v-else-if="field == 'deliveryDate'">
        <div class="dateText">{{ deliveryDate }}</div> 
    </div>
    <div class="cell" :class="isNotifications ? 'cellcreated-date' : 'cell'" v-else-if="['nextVisitDate','tachographDate','itvDate', 'date', 'created'].includes(props.field)">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      {{ date }}
    </div>
    <div class="cell cell-switch" v-else-if="field == 'has_client'">
      <div class="form-switch">
          <MazSwitch
              v-model="item.has_client"
              color="primary"
              :id="item.key"
              @change="updateLinkedClient"
          >
          </MazSwitch>
      </div>
    </div>
    <div class="cell carSync" :class="{ 'mobile': isMobileView() }" v-else-if="field == 'carSync'">
      <div class="button-wrapper">
        <div class="carSync-actions d-flex flex-row">
          <YBtn class="carSync-buttons"
            secondary
            :class="'carSyncActivate'"
            :loading="tableStates[item.id]?.activate.loading"
            :disabled="tableStates[item.id]?.activate.disabled"
            :label="t('field.activate')"
            :id="item.id+'_enable'"
            :rounded="true"
            roundedSize="full"
            @click="syncVehicles('activate')"
            >
          </YBtn>
          <YBtn class="carSync-buttons"
            secondary
            :class="'carSyncDeactivate'"
            :loading="tableStates[item.id]?.deactivate.loading"
            :disabled="tableStates[item.id]?.deactivate.disabled"
            :label="t('field.deactivate')"
            :id="item.id+'_disable'"
            :rounded="true"
            roundedSize="full"
            @click="syncVehicles('deactivate')"
            >
          </YBtn>
        </div>
      </div>
    </div>
    <div class="cell" v-else-if="field == 'status' && type == 'statusLog' && (item.wfStatus == 99 || item.wfStatus == 100)">
      {{ $t("workfiles.state.quotation." + getValueByPath(item, src)) }}
    </div>
    <div class="cell" v-else-if="field == 'reparationTime'">
      {{ convertMinutesToHoursAndMinutes(getValueByPath(item, src)) }}
      <div class="d-flex cell-status-category-terciary-wrapper" style="padding-left: 8px;">
          <span class="cell-status-category-terciary time-pill" v-if="item.reparationTime > 1440 && over24hFilterIsPresent">+24h</span>
      </div>
    </div>
    <div class="cell" v-else-if="field == 'status' && type == 'statusLog'">
      {{ $t("workfiles.state.primary." + getValueByPath(item, src)) }}
    </div>
    <div class="cell cell-status" v-else-if="field == 'status'">
      <div class="cell-status-icon-wrapper status" :style="{'background-color': item.statusColor}" >
        <img v-if="item[src] == 99" style="margin-left:-6px" v-bind:src="'/assets/workfiles/'+ matchStatusToSvg(item[src],props.type) +'.svg'" />
        <img v-else v-bind:src="'/assets/workfiles/'+ matchStatusToSvg(item[src],props.type) +'.svg'" />
      </div>
      <div class="cell-status-category">
        <span class="cell-status-category-primary">{{ $t(getStatusText(item.status,'primary', item.type)) }}</span>
        <span class="cell-status-category-secondary" v-if="item.status == 0">{{ props.item.scheduleDate != '' ? formatDate(props.item.scheduleDate * 1000) : '' }}</span>
        <span class="cell-status-category-secondary" v-else-if="item.status == 14">{{ props.item.scheduleDate != '' ? formatDate(props.item.scheduleDate * 1000) : '' }}</span>
        <span class="cell-status-category-secondary" v-else-if="item.status == 7">{{ props.item.scheduleDate != '' ? formatDate(props.item.scheduleDate * 1000) : '' }}</span>
        <span class="cell-status-category-secondary" v-else-if="item.status == 8">{{ props.item.scheduleDate != '' ? formatDate(props.item.scheduleDate * 1000) : '' }}</span>
        <span class="cell-status-category-secondary" v-else-if="item.status == 11">{{ props.item.deliveryDate != '' ? formatDate(props.item.deliveryDate * 1000) : '' }}</span>
        <span class="cell-status-category-secondary" v-else-if="item.status == 15">{{ props.item.scheduleDate != '' ? formatDate(props.item.scheduleDate * 1000) : '' }}</span>
        <span class="cell-status-category-secondary" style="line-height:1;" v-else-if="item.status == 5 || item.status == 100">{{ $t(getStatusText(item.status,'secondary', item.type)) }}</span>
        <span class="cell-status-category-secondary" v-else>{{ $t(getStatusText(item.status,'secondary', item.type)) }}</span>        
        <div class="d-flex cell-status-category-terciary-wrapper" style="padding-left: 8px;">
          <span class="cell-status-category-terciary" v-if="item.outOfStock == 1 && outOfStockFilterIsPresent">{{ $t("field.missing_parts") }}</span>
        </div>
      </div>
    </div>
    <div class="cell cell-status-mobile" v-else-if="field == 'status-mobile'">
        <div class="d-flex cell-status-category-terciary-wrapper-mobile" style="padding-left: 8px;">
          <span class="cell-status-category-terciary" v-if="item.outOfStock == 1 && outOfStockFilterIsPresent">{{ $t("field.missing_parts") }}</span>
          <span class="cell-status-category-terciary" v-if="item.reparationTime > 1440 && over24hFilterIsPresent">+24h</span>
      </div>
    </div>
    <div class="cell" v-else-if="field == 'status_invitation'">
      {{ $t("invitations.states." + getValueByPath(item, src)) }}
    </div>
    <div class="cell-img" v-else-if="field == 'brand' && (item.vehicle.image.length || item.vehicle.svgImage && item.vehicle.svgImage.length)">
      <img :src="item.vehicle.svgImage"  v-if="item.vehicle.svgImage && item.vehicle.svgImage.length"/>
      <img :src="item.vehicle.image"  v-else-if="item.vehicle.image.length"/>
    </div> 
    <div class="cell cell-plate-vin" v-else-if="field == 'plate_vin'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span>{{ getValueByPath(item, 'vehicle.plate')}}</span>
      <span style="word-wrap: break-word;">{{ getValueByPath(item, 'vehicle.vin')}}</span>
    </div>
    <div class="cell cell-client" v-else-if="field == 'client' && type != 'full'">
      <span>{{ getValueByPath(item, 'client.firstname')}}</span>
      <span>{{ getValueByPath(item, 'client.lastname')}}</span>
    </div>    
    <div class="cell cell-notifications" v-else-if="field == 'message' && type == 'notificationInterpolation'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <i18n-t :keypath="'notifications'+'.'+item.message" tag="p">
          <template #or>
          <span class="notification-data--bold">{{ getValueByPath(item, 'or') }}</span>
          </template>
          <template #brand>
          <span class="notification-data--bold">{{ getValueByPath(item, 'brand') }}</span>
          </template>
          <template #model>
          <span class="notification-data--bold">{{ getValueByPath(item, 'model') }}</span>
          </template>
          <template #plate>
          <span class="notification-data--bold">{{ getValueByPath(item, 'plate') }}</span>
          </template>
          <template #vin>
          <span class="notification-data--bold">{{ getValueByPath(item, 'vin') }}</span>
          </template>
      </i18n-t>
    </div>
    <div class="cell text-rights cell-btn w-100" v-else-if="field == 'btnVehicleState'">
      <YBtn v-if="item['has_vehicle'] == true" class="table-btn w-100" :rounded="true" roundedSize="full" @click="updateTableVehicle()">
        {{ t("field.added") }}
      </YBtn>
      <YBtn v-else class="table-btn-inactive w-100" :rounded="true" roundedSize="full" @click="updateTableVehicle()">
        {{ t("field.add") }} 
      </YBtn>
    </div>
    <div class="cell text-rights cell-link-file w-100" v-else-if="link && type == 'file'">
      <a :href="link" style="font-size: 20px;">
          <font-awesome-icon icon="fa-solid fa-file-pdf" />
      </a> 
    </div>
    <div class="cell text-rights cell-link w-100" v-else-if="link">
      <YBtn v-if="type == 'view'" class="table-btn w-100" :rounded="true" roundedSize="full">
        <router-link :to="link" class="router-link">
          {{ t("field.see") }}
        </router-link>
      </YBtn>
      <YBtn v-if="type == 'edit'" class="table-btn w-100" :rounded="true" roundedSize="full">
        <router-link :to="link" class="router-link">
          {{ t("field.edit") }}
        </router-link>
      </YBtn>
      <YBtn v-if="type == 'delete'" class="table-btn w-100" :rounded="true" roundedSize="full">
        <router-link :to="link" class="router-link">
          {{ t("field.delete") }}
        </router-link>
      </YBtn>    
      <YBtn v-if="type == 'add'" class="table-btn w-100" :rounded="true" roundedSize="full">
        <router-link :to="link" class="router-link">
          {{ t("field.add") }}
        </router-link>
      </YBtn>
      <YBtn v-if="type == 'notificationLink'" style="padding: 0px; border-width: 0px;" :rounded="true" roundedSize="full" variant="link">
        <router-link :to="link" class="router-link" v-html="ull"></router-link>
        <!-- <YBtn v-else-if="type == 'doubleLink'" style="padding: 0px; border-width: 0px;"
    @click="setUserToEdit" v-for="(id, index) in doubleLink" variant="link">
      <router-link :to="id" class="router-link" v-html="ull"></router-link>
    </YBtn>  -->
      </YBtn>
    </div>
    <YBtn v-else-if="type == 'doubleLink'" style="padding: 0px; border-width: 0px;"
    @click="setUserToEdit" v-for="(id, index) in doubleLink" variant="link">
      <router-link :to="id" class="router-link" v-html="ull"></router-link>
    </YBtn>    
    <div class="cell text-rights cell-buttons w-100" v-else-if="field == 'buttons'">
      <div v-for="b in buttons">
        <router-link :to="b.link" v-html="b.svg" v-if="b.type == 'detail'" @click="setUserToEdit">
        </router-link>
        <YBtn :href="b.link" style="font-size: 20px;" v-else-if="item.data.negotiation_url && item.data.negotiation_url.length" v-html="b.svg"
        target="_blank" variant="link">
        </YBtn>
      </div>
      </div>
    <div class="cell cell-collapse" v-else-if="field == 'collapse'">
      <font-awesome-icon :class="{'expanded': isExpanded, 'rotate0deg': isExpanded, 'rotate90deg': !isExpanded}" icon="fa-solid fa-chevron-right"/>
    </div>
    <div class="cell cell-or" :class="{'cell-or-workfile' : props.table === 'vehicleWorkfilesList'}" :style="styles" v-else-if="field == 'orNumber'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span v-if="getValueByPath(item, src)"> {{ getValueByPath(item, src) }}</span> 
    </div>
    <div class="cell cell-branch" :style="styles" v-else-if="field == 'branch'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span>{{ getValueByPath(item, src) }}</span>
    </div>
    <div class="cell cell-branch cell-branch-home" :style="styles" v-else-if="field == 'branchHome'">
      {{ getValueByPath(item, src) }}
    </div>
    <div class="cell cell-model" :style="styles" v-else-if="field == 'model'">
      <span>{{ getValueByPath(item, 'vehicle.brand') }}</span>
      <span>{{ getValueByPath(item, src) }}</span>
      <span>{{ getValueByPath(item, 'vehicle.plate')}}</span>
    </div>
    <div class="cell cell-plate" :style="styles" v-else-if="field == 'plate'">
      {{ getValueByPath(item, src) }}
    </div>
    <div class="cell cell-vin" :style="styles" v-else-if="field == 'vin'">
      {{ getValueByPath(item, src) }}
    </div>
    <div class="cell cell-vehic-client" v-else-if="field == 'client'">
      {{ getValueByPath(item, src) }}
    </div>  
    <div class="cell cell-cif" :style="styles" v-else-if="field == 'vatNumber'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span v-if="getValueByPath(item, src)"> {{ getValueByPath(item, src) }}</span> 
    </div>  
    <div class="cell cell-name" :style="styles" v-else-if="field == 'firstname' || field  == 'name'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span v-if="getValueByPath(item, src)"> {{ getValueByPath(item, src) }}</span> 
    </div>  
    <div class="cell cell-lastname" :style="styles" v-else-if="field == 'lastname'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span v-if="getValueByPath(item, src)"> {{ getValueByPath(item, src) }}</span> 
    </div>  
    <div class="cell cell-name" :style="styles" v-else-if="field == 'secondLastname' || field == 'second_lastname'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span v-if="getValueByPath(item, src)"> {{ getValueByPath(item, src) }}</span> 
    </div>  
    <div class="cell cell-mail" :style="styles" v-else-if="field == 'email'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span v-if="getValueByPath(item, src)"> {{ getValueByPath(item, src) }}</span> 
    </div>  
    <div class="cell cell-adress" :style="styles" v-else-if="field == 'address'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span v-if="getValueByPath(item, src)"> {{ getValueByPath(item, src) }}</span> 
    </div> 
    <div class="cell cell-cif-client" :style="styles" v-else-if="field == 'vat_number'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span v-if="getValueByPath(item, src)"> {{ getValueByPath(item, src) }}</span> 
    </div> 
    <div class="cell cell-created" :style="styles" v-else-if="field === 'or'">
      <span v-if="getValueByPath(item, src)" class="title">{{ title }}</span>
      <span v-if="getValueByPath(item, src)"> {{ getValueByPath(item, src) }}</span> 
    </div> 
    <div class="cell" :style="styles" v-else-if="field == 'read'">
      {{ getValueByPath(item, src) ? $t('field.yes') : $t('field.no') }}
    </div> 
    <div class="cell" :style="styles" v-else>
      {{ getValueByPath(item, src) }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cell-status-mobile{
  display: none;
}
.custom-table-cell, .custom-table-cell-home {
  align-items: center;
  display: flex;
  min-height: 60px;
  .cell {
    // white-space: nowrap;
    text-overflow: ellipsis;
    overflow: visible;
    color: black;
    .form-switch{
      padding-left: 40px;
    }
  }
  .cell-date-range{
    display: flex;
    flex-direction: column;
    font-size: 17px;
    color: black;
    .startDate, .endDate{
      display: flex;
      flex-direction: row;
      gap: 0.2rem;
      padding: 0;
      line-height: 1.2;
      align-items: center;
    }
    .startDate{
      align-items: end ;
    }
    .endDate{
      align-items: start;
    }
    .dateIcon{
      padding-bottom: 2px;
    }
  }
  .cell-img {
    display: flex;
    width: 100%;
    align-content: center;
    justify-content: center;
    padding-right: 2rem;
    img {
      max-height: 35px;
      max-width: 70px;
      width: auto;
      height: auto;
      object-fit: contain;
      @media (min-width: 577px) and (max-width: 1024px) and (orientation: portrait) {
        max-height: 40px;
        max-width: 85px;
      }
    }
  }
  .cell-status{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    @media (max-width: 576px) {
        justify-content: flex-start;
        font-size: 17px !important;
      }
    .cell-status-icon-wrapper{
      width: 38px;
      height: 38px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: 1024px) {
        width: 12px;
        height: 12px;
      }
      // padding: 10px;
      img{
        width:25px;
        height:25px;
        @media (max-width: 1024px) {
        display: none;
      }
      }
    }
    .cell-status-category{
      display: flex;
      flex-direction: column;
      color: black;
      .cell-status-category-primary{
        font-family: 'CircularStd-Bold';
        white-space: normal;
        padding: 7px 22px 0px 8px;
        font-size: 15px;
        width: 100%;
        max-width: 120px;
        line-height: 0.95;
        @media (max-width: 1024px) {
        font-size: 13px;
      }
      }
      .cell-status-category-secondary{
        font-family: 'CircularStd-Book';
        white-space: normal;
        padding: 0px 0px 0px 8px;
        font-size: 12px;
        width: 100%;
        opacity: 0.52;
      }
    }
  }
  .cell-status-category-terciary-wrapper{
    flex-direction: column;
    gap: 1px;
    align-items: start;
    @media (max-width: 576px) {
    display: none !important;
  }
  }
  .cell-status-category-terciary{
    font-family: 'CircularStd-Bold';
    white-space: normal;
    padding: 2px 3px;
    font-size: 10px;
    opacity: 1;
    color: white;
    background-color: #ff0061;
    border-radius: 30px;
    line-height: 1;
  }
  .time-pill{
    position: absolute;
    bottom: 20px;
    left: 40px;
  }
  .cell-collapse{
    color: #B2BDCE;
    font-size: 17px;
    display: flex;
    justify-content: end;
    width:85%;
    transition: transform 0.3s ease;
    transition-property: transform;
    transition-delay: ease-in;
  }
  .cell-collapse > * {
    pointer-events: none;
  }
  .cell-collapse:hover{
    cursor: pointer;
  }
  .cell-plate-vin{
    span:nth-of-type(2){
      @media (max-width:576px) {
        display: none;
        margin-left: 3.8rem;
        margin-top: 30px;
      }
    }
  }
  .cell-plate-vin, .cell-client{
    display: flex;
    flex-direction: column;
    @media (max-width:576px) {
      justify-content: flex-start;
      align-items: flex-start;
    }
    span:nth-of-type(2){
      font-family: 'CircularStd-Bold';
      font-size: 16px;
      color: black;
      @media (max-width:576px) {
      font-size: 20px;
    }
    }
    span:nth-of-type(3){
      font-family: 'CircularStd-Book';
      color: black;
      @media (max-width:576px) {
      font-size: 18px;
      margin-top: -2px;
    }
    }
  }
  .cell-plate{
    padding-left: 2.5rem;
    font-family: 'CircularStd-Bold';
    font-size: 16px;
    color: black;
  }
  .cell-client{
    word-break: break-word !important;
    span{
      font-size: 14px !important;
      word-break: break-word;
      @media (min-width: 577px) and (max-width: 1024px) and (orientation: portrait) {
      font-size: 18px !important;
      display: none;
    }
    }
    span:nth-of-type(1),
    span:nth-of-type(2){
      font-family: 'CircularStd-Book';
    }
  }
  .cell-or{
    color: black !important;
    font-family: 'CircularStd-Bold';
    word-break: break-word;
    text-overflow: unset;
    text-align: center;
    font-size: 16px !important;
  }
  .cell.cell-or{
    width: 100px;
  }
  
  .title{
    display: none;
  }
  .cell-buttons{
    display: flex;
    gap: 10px;
    // justify-content: end;
    align-items: center;
  }
  .cell-buttons img:hover{
    fill: aqua;
    stroke: red;
  }
  .cell-branch {
    display: -webkit-box;
    -webkit-line-clamp: 3;
      line-clamp: 3; /* Standard property for compatibility */
    -webkit-box-orient: vertical;  
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
    @media (max-width: 1024px) {
        font-size: 16px;
      }
  }
    .inline-checkin-icon {
      width: 14px;
      height: 14px;
      // margin-right: 4px;
      position: relative;
      // top: 2px;
    }
  
  .table-btn {
    background-color: v-bind(userColor);
    color: white;
    border: none;
    padding: 2px 25px;
    border-radius: 0.3em;
  }
  .table-btn-inactive {
    background-color: #D9D9D9;
    color: #6e6c6c;
    border: none;
    padding: 2px 25px;
    border-radius: 0.3em;
  }
  .double-btn {
    padding: 0 5px;
  }
  .cell-link {
    text-align: right;
    gap: 0.5rem;
  }
  .router-link {
    text-decoration: none;
    font-weight: 600; 
    color: white;
    display: inline-block;
    width: 100%;
  }
  .form-check-input:checked {
    background-color: v-bind(userColor) !important;
  }
  .form-check-input{
      border-color: #CBD5E1;
  }
  .carSync-actions{
        @media (min-width: 687px) and (max-width: 720px) and (orientation: portrait){
          // display: flex !important;
          // flex-direction: column !important;
          gap: 2px !important;
          margin-bottom: 1rem;
          width: 300px !important;

          .carSync-buttons{
            min-width: 0 !important;
            width: 6.7rem !important;
          }

          
        }

        @media (min-width: 577px) and (max-width: 686px) and (orientation: portrait){
          
          margin-bottom: 2rem;
          margin-top: 1rem;
          
        }
    gap: 10px;
    .carSyncDeactivate, .carSyncActivate{
      min-width: 115px;
      padding: 12px 5px;
    }
    button {
        background: linear-gradient(to right, v-bind(color) 50%, transparent 50%);
        background-size: 200% 100%;
        background-position: right bottom;
        transition: all .5s ease-out;
    }
    button.carSyncActivate:hover {
        color: white;
        background-position: left bottom;
    }
    button.carSyncDeactivate:hover {
        color: white;
        background-position: left bottom;
    }    
  }
  .vehicle-message{
    @media (min-width: 687px) and (max-width: 720px) and (orientation: portrait){
      bottom: 0.2rem;
      
  }
  
  @media (min-width: 577px) and (max-width: 686px) and (orientation: portrait){
    bottom: 1.5rem;
    margin-bottom: 2rem;
    max-height: 4rem;
  }
  
}
}

.vehicle-message{
  max-width: 15rem;
  justify-content: center;
  align-items: center;

  .vehicle-message-content{
    margin-top: 0.7rem; 
    margin-bottom: 0.3rem;
    padding: 0.5rem;
    text-align: center;
  }
}



@media (max-width:576px) {
  .cell-status-icon-wrapper{
    position: absolute;
    top: 0;
  }
  .cell-status-category{
    text-align: left;
    margin-left: 7px;
  }
  .cell-status-mobile{
    display: block;
    position: absolute;
    right: -30px;
    top: 0px;
    .cell-status-category-terciary-wrapper-mobile{
        flex-direction: column;
        gap: 1px;
        align-items: end;
        .cell-status-category-terciary{
        font-family: 'CircularStd-Bold';
        white-space: normal;
        padding: 2px 3px;
        font-size: 12px;
        opacity: 1;
        color: white;
        background-color: #ff0061;
        border-radius: 30px;
        line-height: 1;
      }
    }
  }
  .custom-table-cell, .custom-table-cell-home {
    max-width: 70dvw;
  }
  .title{
    display: none;
  }
  .custom-table-cell > .cell:empty{
    display: none;
  }
  .cell-or{
    color: black !important;
      font-family: 'CircularStd-Bold';
      font-size: 16px !important;
      margin-left: 0px;
  }
  .cell-cif, .cell-name, .cell-mail, .cell-lastname, .cell-adress, .cell-cif-client, .cell-created, .cell-notifications, .cellcreated-date{
    display: flex;
    flex-direction: column;
    gap: 5px;
    color: black !important;
    font-family: "CircularStd-Bold";
    text-align: left;
    font-size: 18px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    .title{
        display: block;
        font-family: 'CircularStd-Book';
        font-size: 16px;
        color: #C9C9C9;
        display: block !important;
        text-align: left;
        margin-bottom: -5px;
    }
    span:nth-child(2){
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  
  .cell-notifications{
    white-space: wrap;
    width: 100%;
    height: 100%;
    span:nth-child(2){
      display: inline;
    }
  }
  .cell-cif{
    span:nth-child(2){
      font-size: 25px !important;
    }
  }
  .cell-lastname{
    span:nth-child(2){
      display: flex;
    }
  }
  .cell-or::before{
    content: "Nº";
  }
  .cell-model{
    display: inline-block;
    flex-direction: row;
    gap: 3px;
    flex-wrap: nowrap;
    font-family: 'CircularStd-Bold';
    font-size: 20px !important;
    margin-top: 0px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    span{
      margin-right: 3.5px;
    }
  }

  .cell-model, .cell-plate{
    font-weight: bold;
    font-size: 20px;
    margin-top: -10px;
  }
  .cell-plate{
    padding-left: 4.7rem !important;
    margin-top: -28px;
    font-size: 20px !important;
  }
  .cell-vin{
    color:v-bind(userColor) !important;
    font-weight: bold;
    font-size: 20px;
    margin-top: -18px;
  }

  .cell-vehic-client{
    font-size: 16px;
    margin-top: -10px;
  }
  
}

//tablets verticales
@media (min-width: 577px) and (max-width: 1024px) and (orientation: portrait){
  .cell-status-mobile{
    display: block;
    position: absolute;
    right: 0;
    top: 0px;
    .cell-status-category-terciary-wrapper-mobile{
        flex-direction: column;
        gap: 1px;
        align-items: end;
        .cell-status-category-terciary{
        font-family: 'CircularStd-Bold';
        white-space: normal;
        padding: 2px 3px;
        font-size: 12px;
        opacity: 1;
        color: white;
        background-color: #ff0061;
        border-radius: 30px;
        line-height: 1;
      }
    }
  }
  .title{
        font-family: 'CircularStd-Book';
        font-size: 16px;
        color: #C9C9C9;
        display: block !important;
        text-align: left;
        margin-bottom: -5px;
  }
  .cell-cif, .cell-name, .cell-mail, .cell-lastname, .cell-adress, .cell-cif-client, .cell-created{
    display: flex;
    flex-direction: column;
    gap: 5px;
    color: black !important;
    font-family: "CircularStd-Bold";
    text-align: left;
    font-size: 18px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    .title{
        display: block;
        font-family: 'CircularStd-Book';
        font-size: 16px;
        color: #C9C9C9;
        display: block !important;
        text-align: left;
        margin-bottom: -5px;
    }
    span:nth-child(2){
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .custom-table-cell > .cell:empty{
    display: none;
  }

  .cell-model{
    font-weight: bold;
    font-size: 20px !important;
    span:nth-of-type(1){
      display: none;
    }
    span:nth-of-type(3){
      display: none;
    }
  }

  .cell-model, .cell-plate, .cell-vehic-client{
    font-weight: bold;
    font-size: 18px;
  }
  .cell-plate{
    padding-left: 15px !important;
  }
  .cell-vin{
    color:v-bind(userColor) !important;
    font-weight: bold;
    font-size: 18px;
    margin-top: -25px
  }
  .custom-table-cell{
    .cell-client{
    flex-direction: row !important;
    gap: 3px;
    word-break: break-word !important;
  }
  }
  
  .cell-or{
    font-size: 18px !important;
      margin-top: 10px;
      font-weight: bold !important;
      margin-left: 0px;
      text-align: left !important;
      span{
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
  }
  .cell-vin, .cell-vehic-client{
    display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
  .cell-plate-vin{
    span:nth-of-type(3){
      margin-top: -7px !important;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span:nth-of-type(2){
      margin-top: -3px !important;
    }
  }
  .dateIcon{
    display: none;
    }
    .dateText{
      font-size: 14.5px !important;
    }
    .cell-status-category-terciary-wrapper{
      display: none !important;
    }
    .cell-branch, .cell-plate-vin, .cell-date-range{
      span:nth-of-type(1){
        margin-bottom: 0px;
      }
    }
    .cell-date-range-workfile, .cell-or-workfile{
      .title{
        display: none !important;
      }
    }
    .cell-branch{
      span:nth-of-type(2){
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .custom-table-cell  .custom-table-cell-home .cell-img {
    justify-content: start;
  }
}
.dateText{
      font-size: 14.4px !important;
    }
@media (min-width: 769px) and (max-width: 1900px) and (orientation: landscape) {
  .custom-table-cell .custom-table-cell-home .cell-img {
    justify-content: start;
  }
}
.rotate0deg {
  transition: transform 0.3s ease-out;
  transform: rotate(90deg);
}

.rotate90deg {
  transition: transform 0.3s ease-out;
  transform: rotate(0deg);
}
</style>
